export const todayAsIsoRange = (): { before: string; after: string } => {
  const before = new Date();
  const after = new Date();
  before.setUTCHours(24, 0, 0, -1);
  after.setUTCHours(0, 0, 0, 0);

  return { before: before.toISOString(), after: after.toISOString() };
};
